import { render, staticRenderFns } from "./WYSIWYGInput.vue?vue&type=template&id=153dd413&"
import script from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGInput.vue?vue&type=script&lang=js&"
import style0 from "./WYSIWYGInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports